import React from 'react';

function Wrapper(props) {
    return <div className="Wrapper">{props.children}</div>
}

export default Wrapper;